// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"chemicals_wrapper__3xmkm","list":"chemicals_list__3zD9M"};